import * as renderPageDev from './index-dev'
import * as renderPageProd from './index-prod'
import * as registerWindow from './window-render'


function getUrlVars() {
  var vars = [], hash;
  var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  for (var i = 0; i < hashes.length; i++) {
    hash = hashes[i].split('=');
    vars.push(hash[0]);
    if (hash.length > 1) {
      let param = hash[1].split('#');
      if (param.length > 0) {
        vars[hash[0]] = param[0];
      } else {
        vars[hash[0]] = hash[1];
      }
    }
  }
  return vars;
}


var urlParams = getUrlVars();
if (process.env.NODE_ENV === "development") {

  renderPageDev.handlePage(urlParams)
} else {
  //Do nothing
  renderPageProd.handlePage(urlParams)
}

registerWindow.registerRender()




// WEBPACK FOOTER //
// ./src/index.js